export default __webpack_public_path__ + "static/media/Adling_Wedding-testimonial.b07ae8da.jpg";